import { t } from 'i18next';
import { SocialLoginBtnProps } from './type';

const DRAFT_LABEL_KEYS: Record<string, string> = {
  kakao: 'authDraft.continueKakao',
  google: 'authDraft.continueGoogle',
  naver: 'authDraft.continueNaver',
  apple: 'authDraft.continueApple',
};

export default function SocialLoginBtn({
  onClick,
  backgroundColor = 'bg-white',
  fontColor = 'text-gray-black',
  additionalStyle,
  icon,
  text,
  variant = 'legacy',
}: SocialLoginBtnProps) {
  if (variant === 'draft') {
    const labelKey = DRAFT_LABEL_KEYS[text] ?? `login.${text}`;
    return (
      <button
        type="button"
        onClick={onClick}
        className={`login-social-btn login-social-btn--${text} ${backgroundColor} ${fontColor} ${additionalStyle ?? ''}`}
      >
        <span className="flex shrink-0 items-center justify-center [&_svg]:h-6 [&_svg]:w-6">{icon}</span>
        <span>{t(labelKey)}</span>
      </button>
    );
  }

  return (
    <button
      type="button"
      onClick={onClick}
      className={`flex items-center justify-center ${backgroundColor} md:h-[54px] md:w-[357px] md:rounded-full md:px-7 ${additionalStyle}
        h-[48px] w-[48px] rounded-[8px] `}
    >
      {icon}
      <span
        className={`hidden px-5 md:block ${fontColor} text-[16px] font-medium font-weight-600 leading-[150%]`}
      >
        {t(`login.${text}`)}
      </span>
    </button>
  );
}
